module.exports = __webpack_public_path__ + "static/media/retailman.29dd1dda.jpg";